import { createSignal } from '@verclam/pulsar';

/** `null` when no deletion is pending confirmation; otherwise the id of the document to confirm. */
const documentToDeleteSignal = createSignal<number | null>(null);

export const openDocumentToDelete = (documentId: number): void => {
	documentToDeleteSignal.value = documentId;
};

export const closeDocumentToDelete = (): void => {
	documentToDeleteSignal.value = null;
};

export default documentToDeleteSignal;
